export default "__VITE_ASSET__DGpGe6Ij__"